import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import LikutGoodsRow from './LikutGoodsRow';
import LikutExistGoodsRow from './LikutExistGoodsRow';

interface Props {
    azmanotList: any[];
    existGoodsInPallet?: any[];
    selecteble?: boolean;
    defaultPackageList: any[];
    isWeightCalculation: boolean;
    isAddIdToDesc: boolean;
    isOffice: boolean;
    isAllowMultipleSave: boolean;
    recID: number | null;
    setRecID: (id: number) => void;
    setGoodsCode: (code: string) => void;
    editOrderRow: (problem: number, reson: number) => void;
    selectGoodForLikut: (index: number) => void;
    handleSelectOrderLine: (recID: number) => void;
    handleOpenProductLocationModal: (product: any) => void;
    setDefaultPacks: (item: any) => void;
    deleteFromPallet: (id: number, item: any) => void;
}

const LikutGoodsListView: React.FC<Props> = ({
    azmanotList,
    existGoodsInPallet,
    selecteble,
    defaultPackageList,
    isWeightCalculation,
    isAddIdToDesc,
    isOffice,
    isAllowMultipleSave,
    recID,
    setRecID,
    setGoodsCode,
    editOrderRow,
    selectGoodForLikut,
    handleSelectOrderLine,
    handleOpenProductLocationModal,
    setDefaultPacks,
    deleteFromPallet,
}) => {
    const [t] = useTranslation(['likut']);
    const hasExist = (existGoodsInPallet?.length ?? 0) > 0;
    const lastIndex = (azmanotList?.length ?? 0) - 1;
    const lastExistIndex = (existGoodsInPallet?.length ?? 0) - 1;

    return (
        <>
            {azmanotList?.map((item, index) => (
                <LikutGoodsRow
                    key={item.id ?? item.RecID}
                    item={item}
                    index={index}
                    isLast={!hasExist && index === lastIndex}
                    selecteble={selecteble}
                    defaultPackageList={defaultPackageList}
                    isWeightCalculation={isWeightCalculation}
                    isAddIdToDesc={isAddIdToDesc}
                    isOffice={isOffice}
                    isAllowMultipleSave={isAllowMultipleSave}
                    recID={recID}
                    setRecID={setRecID}
                    setGoodsCode={setGoodsCode}
                    editOrderRow={editOrderRow}
                    selectGoodForLikut={selectGoodForLikut}
                    handleSelectOrderLine={handleSelectOrderLine}
                    handleOpenProductLocationModal={handleOpenProductLocationModal}
                    setDefaultPacks={setDefaultPacks}
                />
            ))}
            {hasExist && (
                <>
                    <DivideSection>{t('likut_sectionmain_inpallet_title')}</DivideSection>
                    {existGoodsInPallet?.map((item, index) => (
                        <LikutExistGoodsRow
                            key={item.RecID}
                            item={item}
                            isLast={index === lastExistIndex}
                            deleteFromPallet={deleteFromPallet}
                        />
                    ))}
                </>
            )}
        </>
    );
};

export default LikutGoodsListView;

const DivideSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    font-size: ${({ theme }) => theme.text.sm};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.ink3};
    font-family: ${({ theme }) => theme.fonts.sans};
    background: ${({ theme }) => theme.colors.bg};
    border-bottom: 1px solid ${({ theme }) => theme.colors.line2};
`;
